// Copyright (c) 2016 Deere & Company

import * as busyCounter from '../../../../shared/action-creators/busy-counter';
import {
    checkClaimValidity,
    removeEmptyPins
} from '../services/claim-validation-helper';
import actions from '../action-list';
import {formatClaimNumber} from '../../../../shared/services/format-claim-number';
import {infoAlertBar} from '../../../../shared/services/alert-bar';
import {isClaimEditable} from '../../../shared/services/claim-shared-helper';
import {postClaim} from '../../../shared/repositories';
import {routerActions} from 'react-router-redux';
import {translate} from '../../../../shared/services/translation-service';
import {updateIsActionButtonDisabled} from './is-action-button-disabled';

export const createMassChannelPdiClaim = claim =>

    async (dispatch, getState) => {

        dispatch(busyCounter.increaseBusyCounter());

        updateIsActionButtonDisabled(true)(dispatch);

        const isValidClaim = getState().claims.massChannelPdi.isValidClaim;
        const trimmedClaim = removeEmptyPins(claim);

        try {

            const updatedClaim = await postClaim(trimmedClaim, 'mass-channel-pdi-claims');

            const selectedAction = updatedClaim.selectedAction.id;
            const validationStatus = updatedClaim.validationFailed;

            if (checkClaimValidity(isValidClaim, validationStatus, selectedAction)) {

                dispatch({
                    type: actions.UPDATE_CLAIM_MASS_CHANNEL_PDI_IS_VALID_CLAIM,
                    validity: true
                });

            }

            infoAlertBar(translate('CLAIM_UPDATED_SUCCESSFULLY'));

            if (['DRAFT', 'SAVE_VALD'].includes(selectedAction) && updatedClaim.claimNumber) {

                dispatch(routerActions.replace(`/claims/mass-channel-pdi/edit/${formatClaimNumber(updatedClaim.claimNumber)}`));

            }

            dispatch({
                isEditable: isClaimEditable(validationStatus, updatedClaim.selectedAction),
                type: actions.UPDATE_CLAIM_MASS_CHANNEL_PDI_IS_EDITABLE
            });

            dispatch({
                type: actions.SET_CLAIM_MASS_CHANNEL_PDI,
                updatedClaim
            });

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

            updateIsActionButtonDisabled(false)(dispatch);

        }

    };



// WEBPACK FOOTER //
// ./src/claim/marketing/mass-channel-pdi/action-creators/validate-claim.js